import { UpdateDisplayGroup, UpdateDisplayGroupVariables } from './__generated__/UpdateDisplayGroup'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

export const UPDATE_DISPLAY_GROUP_MUTATION = gql`
  mutation UpdateDisplayGroup($input: UpdateDisplayGroupInputV2!) {
    updateDisplayGroupV2(input: $input) {
      ... on DisplayGroupErrorV2 {
        type
        error
      }
      ... on DisplayGroupV2 {
        id
        title
        boardStyle
      }
    }
  }
`

export const useUpdateDisplayGroup = () => {
  return useMutation<UpdateDisplayGroup, UpdateDisplayGroupVariables>(UPDATE_DISPLAY_GROUP_MUTATION)
}
